/**
 * Droits (scopes) d'une clé d'API, tels que l'API les accepte : copie du
 * catalogue fermé de api/src/lib/apiScopes.ts (tout autre scope est refusé).
 */
export type ApiScope =
  | 'tickets:read'
  | 'tickets:write'
  | 'time:write'
  | 'vault:read'
  | 'vault:write'
  | 'stats:read'
  | 'admin:read'
  | 'admin:write';

export interface ScopeGroup {
  title: string;
  scopes: { scope: ApiScope; label: string }[];
}

export const API_SCOPE_GROUPS: ScopeGroup[] = [
  { title: 'Points et messages', scopes: [{ scope: 'tickets:read', label: 'Lecture' }, { scope: 'tickets:write', label: 'Écriture' }] },
  { title: 'Temps passé', scopes: [{ scope: 'time:write', label: 'Écriture' }] },
  { title: 'Coffre de secrets', scopes: [{ scope: 'vault:read', label: 'Lecture' }, { scope: 'vault:write', label: 'Écriture' }] },
  { title: 'Statistiques', scopes: [{ scope: 'stats:read', label: 'Lecture' }] },
  { title: 'Administration', scopes: [{ scope: 'admin:read', label: 'Lecture' }, { scope: 'admin:write', label: 'Écriture' }] },
];

/** Cocher une écriture coche la lecture du même domaine. */
export const SCOPE_READ_COMPANION: Partial<Record<ApiScope, ApiScope>> = {
  'tickets:write': 'tickets:read',
  'time:write': 'tickets:read',
  'vault:write': 'vault:read',
  'admin:write': 'admin:read',
};

/** Libellé lisible d'un scope stocké (inconnu : affiché tel quel). */
export function scopeLabel(scope: string): string {
  for (const g of API_SCOPE_GROUPS) {
    const o = g.scopes.find((x) => x.scope === scope);
    if (o) return `${g.title} (${o.label.toLowerCase()})`;
  }
  return scope;
}
